import { Text } from '@react-three/drei'
import { useEffect, useState } from 'react'
import { s3PublicStoragePrefix } from '../../../utility'
import * as THREE from 'three'

const CountdownTile: React.FC<{ position: THREE.Vector3; targetDate: Date }> = ({ position, targetDate }) => {
  const [timeLeft, setTimeLeft] = useState<number>(Math.max(targetDate.getTime() - Date.now(), 0))
  const font = `${s3PublicStoragePrefix}custom-static-assets/fonts/countdownFontBold.ttf`

  useEffect(() => {
    const interval = setInterval(() => {
      const diff = Math.max(targetDate.getTime() - Date.now(), 0)
      setTimeLeft(diff)
    }, 1000)

    return () => clearInterval(interval) // Cleanup on unmount
  }, [targetDate])

  const addZero = (num: number) => (num < 10 ? `0${num}` : num)

  const formatTime = (ms: number) => {
    const minutes = addZero(Math.floor((ms / (1000 * 60)) % 60))
    const hours = addZero(Math.floor((ms / (1000 * 60 * 60)) % 24))
    const days = addZero(Math.floor(ms / (1000 * 60 * 60 * 24)))
    const seconds = addZero(Math.floor((ms / 1000) % 60))

    return `${days} ${hours} ${minutes} ${seconds}`
  }

  return (
    <group position={position} rotation={[-Math.PI / 2, 0, 0]}>
      <Text font={font} fontSize={0.175} fontWeight={700} color="#c7c7c7" anchorX={0.45} anchorY={-0.45}>
        {timeLeft > 0 ? formatTime(timeLeft) : 'Time Up!'}
      </Text>
      <Text position={[0, -0.15, 0]} font={font} fontSize={0.04} fontWeight={400} color="#c7c7c7" anchorX={0.45} anchorY={-0.45}>
        {timeLeft > 0 ? '      Tage              Stunden         Minuten        Sekunden' : ''}
      </Text>
    </group>
  )
}

export default CountdownTile
